// extracted by mini-css-extract-plugin
export default {"field":"Input_field__NhS8p","submit":"Input_submit__cYaR-","checkbox":"Input_checkbox__+OE3f","datalist":"Input_datalist__mxE95"};